import { Box, Text } from '@chakra-ui/react'

const LastResponseTime = ({ value }: { value: string | null }) => {
    if (!value) {
        return null
    }

    return (
        <Box data-testid="last-response-time">
            <Text fontSize="12px" color="var(--chakra-colors-gray-750)">
                {value}
            </Text>
        </Box>
    )
}

export default LastResponseTime
